import { ILicense } from "Dashboard/domain/ILicense";
import { settingsService } from "Dashboard/services/settings.service";
import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatDate, GetTodayDate } from "utils/dateUtils";
import { selectState } from "../output.slice";
import classes from "../../../../../../styles/g-grid-v2/components/print.module.scss";
import { FormatNumber } from "utils/numberUtils";

interface IProps {
  doPrint: Function;
}

const PrintRequisition = ({ doPrint }: IProps) => {
  const memorandumLogo = useMemorandumLogo();

  const { outputForPrint } = useSelector(selectState);

  const [license, setLicense] = useState<ILicense>({
    companyName: "",
    address: "",
    contactPersonName: "",
    identificationNumber: "",
    landlinePhone: "",
    mobilePhone: "",
    taxId: "",
  });

  useEffect(() => {
    async function getData() {
      try {
        let license = await settingsService.getLicense();
        setLicense(license);
      } catch (e) { }
    }
    getData();
  }, []);

  useEffect(() => {
    doPrint(outputForPrint);
  }, [outputForPrint, doPrint]);

  return (
    <div className={classes.delNote}>
      <div className={classes.delNoteHeader}>
        <div className={classes.col1}>
          {memorandumLogo && <img src={memorandumLogo} alt="" />}
          <div className={classes.companyInfo}>
            <span>{license.address}</span>
            <span>mob {license.mobilePhone}</span>
            <span>tel/fax {license.landlinePhone}</span>
            <span>PIB:{license.taxId}</span>
            <span>MAT br. {license.identificationNumber}</span>
          </div>
        </div>
        <div className={classes.col2}>
          <span>
            TREBOVANJE br:{" "}
            <span className={classes.number}>{outputForPrint?.requisitionId}</span>
          </span>
          <span>- zavodni broj: {outputForPrint?.referenceNumber}</span>
          <span>- lager rezervnih delova</span>
        </div>
        <div className={classes.col3}>
          <span>Resurs:</span>
          <span>{outputForPrint?.service?.resource?.name}</span>
          <span>{outputForPrint?.service?.resource?.registrationPlate}</span>
        </div>
        <div className={classes.additionalInfo}>
          <div></div>
          <div>
            <span>Datum:</span>
            <span className={`${classes.datePos} ${classes.border}`}>
              {outputForPrint && FormatDate(outputForPrint.date)}
            </span>
          </div>
        </div>
      </div>
      <div className={classes.delNoteMain}>
        <div className={classes.prtGrid}>
          <div className={`${classes.row} ${classes.headerX}`}>
            <div className={classes.col}>red. br.</div>
            <div className={classes.col}>šifra</div>
            <div className={`${classes.col} ${classes.left}`}>naziv robe</div>
            <div className={classes.col}>mera</div>
            <div className={`${classes.col} ${classes.left}`}>količina</div>
          </div>
          {outputForPrint &&
            outputForPrint.items.map((item, index) => (
              <div className={classes.row} key={item.outputItemId}>
                <div className={classes.col}>{item.orderNumberWithinOutput}.</div>
                <div className={classes.col}>{item.item.latestItemCode}</div>
                <div className={`${classes.col} ${classes.left} 
                      ${classes.upper} ${classes.strong}`}>
                  {item.item.name}
                </div>
                <div className={classes.col}>{item.item.latestQuantityUnit.name}</div>
                <div className={`${classes.col} ${classes.left} 
                      ${classes.strong}`}>
                  {FormatNumber(item.quantityAmount)}
                </div>
              </div>
            ))}
        </div>
        <div className={classes.separator}></div>

      </div>
      <div className={classes.delNoteFooter}>
        <div className={`${classes.col1} ${classes.hidden}`}>
          <div>
            <span>Izdao:</span>
            <span></span>
          </div>
          <div>
            <span>Datum:</span>
            <span>{GetTodayDate()}</span>
          </div>
          <div className={classes.sigLine}>
            <span>Potpis:</span>
            <span className={classes.line}></span>
          </div>
        </div>
        <div className={`${classes.col2} ${classes.hidden}`}>
          <div>
          </div>
          <div>
            <span>Datum:</span>
            <span>{GetTodayDate()}</span>
          </div>
          <div className={classes.sigLine}>
            <span>Potpis:</span>
            <span className={classes.line}></span>
          </div>
        </div>
        <div className={classes.col3}>
          <div className={classes.sigLine}>
            <span>Potpis:</span>
            <span className={classes.line}></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintRequisition;
